const tours = {
  tour: "رحلة", // translated 
  tours: "جولات", // translated 
  addOn: "اضافه", // translated 
  addOns: "إضافات", // translated 
  availableEscapes: "الهروب المتاحة", // translated 
  availableExperiences: "الخبرات المتاحة", // translated 
  getRequest: "احصل على الطلب", // translated 
  sendRequest: "ارسل طلب", // translated 
};




export default tours;
